import { apiSlice } from "../../../app/apiSlice";

const apiSliceWithTags = apiSlice.enhanceEndpoints({
  addTagTypes: ["Template", "TemplateLibrary"],
});

const templatesApiSlice = apiSliceWithTags.injectEndpoints({
  endpoints: (builder) => ({
    getTemplates: builder.query({
      query: (parameter) => `/template/${parameter}`,
      providesTags: ["Template"],
    }),
    getTemplatesPaginated: builder.query({
      query: ({ page = 1, per_page = 20, q = "" } = {}) => ({
        url: `/template/all`,
        params: { page, per_page, ...(q ? { q } : {}) },
      }),
      providesTags: ["Template"],
    }),
    createTemplate: builder.mutation({
      query: (values) => ({
        url: "/template/create",
        method: "POST",
        body: { ...values },
      }),
      invalidatesTags: ["Template"],
    }),
    updateTemplate: builder.mutation({
      query: (values) => ({
        url: "/template/update",
        method: "PUT",
        body: { ...values },
      }),
      invalidatesTags: ["Template"],
    }),
    deleteTemplate: builder.mutation({
      query: (values) => ({
        url: `/template/${values.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Template"],
    }),
    updateTemplateContent: builder.mutation({
      query: ({ id, content }) => ({
        url: `/template/${id}/content`,
        method: "PATCH",
        body: { content },
      }),
      invalidatesTags: ["Template"],
    }),
    previewTemplate: builder.query({
      query: (id) => ({
        url: `/template/${id}/preview`,
        responseHandler: (response) => response.text(),
      }),
    }),
    getTemplateLibrary: builder.query({
      query: () => `/template/library`,
      providesTags: ["TemplateLibrary"],
    }),
    importLibraryTemplates: builder.mutation({
      query: (values) => ({
        url: "/template/library/import",
        method: "POST",
        body: values,
      }),
      invalidatesTags: ["Template"],
    }),
  }),
});

export const {
  useGetTemplatesQuery,
  useGetTemplatesPaginatedQuery,
  useCreateTemplateMutation,
  useDeleteTemplateMutation,
  useUpdateTemplateMutation,
  useUpdateTemplateContentMutation,
  usePreviewTemplateQuery,
  useGetTemplateLibraryQuery,
  useImportLibraryTemplatesMutation,
} = templatesApiSlice;
